import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { NovedadesModalComponent } from './novedades-modal.component';
import { NovedadesPlataformaComponent } from './novedades-plataforma.component';

@NgModule({
  imports: [CommonModule, NgbModule],
  declarations: [NovedadesPlataformaComponent, NovedadesModalComponent],
  exports: [NovedadesPlataformaComponent],
})
export class NovedadesPlataformaModule {}
